/**
 * @generated SignedSource<<c7019c958b0727ba44e0ed352efb3da6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPITeamScreenQuery$variables = {
  teamId: string;
};
export type KPITeamScreenQuery$data = {
  readonly store: {
    readonly team: {
      readonly " $fragmentSpreads": FragmentRefs<"KPITeamScreen_team">;
    } | null;
  };
};
export type KPITeamScreenQuery = {
  response: KPITeamScreenQuery$data;
  variables: KPITeamScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPITeamScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "KPITeamScreen_team"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPITeamScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": "KPIS",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "KPI"
                  }
                ],
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routines",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Schedule",
                    "kind": "LinkedField",
                    "name": "schedule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecurrenceRule",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "freq",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 7
                      }
                    ],
                    "concreteType": "RoutineOccasionConnection",
                    "kind": "LinkedField",
                    "name": "occasions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineOccasion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sequenceNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "teamId",
                                    "variableName": "teamId"
                                  }
                                ],
                                "concreteType": "RoutineOccasionSection",
                                "kind": "LinkedField",
                                "name": "occasionSections",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "taskExecutions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                      },
                                      (v2/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "formattedNumberValue",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "numberValue",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isCompleted",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskNumber",
                                            "kind": "LinkedField",
                                            "name": "task",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "unit",
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskNumberGoals",
                                            "kind": "LinkedField",
                                            "name": "goals",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "greaterThan",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "lessThan",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TaskExecutionNumber",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoutineSection",
                                    "kind": "LinkedField",
                                    "name": "section",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Team",
                                        "kind": "LinkedField",
                                        "name": "assignedTeam",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "color",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "occasions(first:7)"
                  }
                ],
                "storageKey": "routines(type:\"KPI\")"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5e1f773c4114af43f04bfd8d42163ac3",
    "id": null,
    "metadata": {},
    "name": "KPITeamScreenQuery",
    "operationKind": "query",
    "text": "query KPITeamScreenQuery(\n  $teamId: ID!\n) {\n  store {\n    team(id: $teamId) {\n      ...KPITeamScreen_team\n      id\n    }\n    id\n  }\n}\n\nfragment KPIItemTeamInProgress_RoutineOccasion on RoutineOccasion {\n  id\n  startAt\n  occasionSections(teamId: $teamId) {\n    taskExecutions {\n      __typename\n      ... on TaskExecutionNumber {\n        formattedNumberValue\n        numberValue\n        isCompleted\n        task {\n          unit\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment KPIItemTeam_Routine on Routine {\n  id\n  title\n  icon\n  schedule {\n    rules {\n      freq\n    }\n  }\n  occasions(first: 7) {\n    edges {\n      node {\n        id\n        sequenceNumber\n        startAt\n        endAt\n        ...KPIItemTeamInProgress_RoutineOccasion\n        occasionSections(teamId: $teamId) {\n          id\n          section {\n            id\n            assignedTeam {\n              id\n              color\n            }\n          }\n          taskExecutions {\n            __typename\n            ... on TaskExecutionNumber {\n              id\n              isCompleted\n              numberValue\n              goals {\n                greaterThan\n                lessThan\n              }\n              formattedNumberValue\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment KPITeamScreen_team on Team {\n  id\n  KPIS: routines(type: KPI) {\n    id\n    title\n    ...KPIItemTeam_Routine\n  }\n}\n"
  }
};
})();

(node as any).hash = "208254a82406f98beccc237f9983ad74";

export default node;
